import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  cookieYesSelectors = [
    'div[class*="cky-consent"]',           // consent containers, banners
    'div[class*="cky-modal"]',               // modal dialogs
    'div[class*="cky-btn"]',                 // buttons and button wrappers
    'div[class*="cky-revisit"]',             // revisit consent elements
    'div[class*="cky-hide"]',               // hidden overlay elements
    'div[data-tag*="consent"]'              // data-tag consent elements
  ];

  connect() {
    this.moveCookieYesToPermanentContainer();
    
    this.handleCookiePolicyContainer();

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (this.isCookieYesElement(node)) {
            this.moveCookieYesToPermanentContainer();
          }
          if (this.isPolicyContainer(node)) {
            this.handleCookiePolicyContainer();
          }
        });
      });
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    ['turbo:load', 'turbo:render', 'turbo:before-cache'].forEach(eventName => {
      document.addEventListener(eventName, this.moveCookieYesToPermanentContainer.bind(this));
      document.addEventListener(eventName, this.handleCookiePolicyContainer.bind(this));
    });

    window.addEventListener('resize', this.applyMobilePositioning.bind(this));
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
    
    window.removeEventListener('resize', this.applyMobilePositioning.bind(this));
  }

  moveCookieYesToPermanentContainer() {
    const container = document.getElementById('cookieyes-container');
    if (!container) return;

    this.cookieYesSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        if (!container.contains(element) && element.id !== 'cookieyes-container') {
          container.appendChild(element);
        }
      });
    });

    this.applyMobilePositioning();
  }

  applyMobilePositioning() {
    const revisitButtons = document.querySelectorAll('.cky-revisit-bottom-left');
    revisitButtons.forEach(revisitButton => {
      if (window.innerWidth < 1024) {
        revisitButton.style.bottom = '60px';
      } else {
        revisitButton.style.bottom = '15px';
      }
      revisitButton.style.zIndex = '10';
    });
  }

  isCookieYesElement(element) {
    if (element.nodeType !== Node.ELEMENT_NODE) return false;
    return this.cookieYesSelectors.some(selector => element.matches(selector));
  }

  isPolicyContainer(element) {
    if (element.nodeType !== Node.ELEMENT_NODE) return false;
    return element.id === 'cky-policy-container' || element.querySelector('#cky-policy-container') !== null;
  }

  handleCookiePolicyContainer() {
    const policyContainer = document.getElementById('cky-policy-container');
    const policyHeading = document.getElementsByClassName('cookie-policy-h1')[0];
    
    if (policyContainer) {
      policyContainer.classList.add(
        'px-4', 'md:px-10', 'lg:px-20', 'xl:px-40', '2xl:px-80', 'py-6'
      );
      
      if (policyHeading) {
        policyHeading.classList.add('!text-3xl', '!font-bold', '!my-4');
      }

      const currentPath = window.location.pathname;
      policyContainer.style.display = currentPath.includes('/cookie-policy/') 
        ? 'block' 
        : 'none';
    }
  }
}

